import loadable from '@loadable/component';

export const KplSiteWrapper = loadable(
  () => import(/* webpackChunkName: "kpl-site" */ './KplSiteWrapper'),
);
